import React from 'react'

export default ({field, name, ...rest}) => {
    let id = 'input_checkbox_'+field;

    return (
        <div className="checkbox">
            <input type="checkbox" id={id} name={field} {...rest}/>
            <label htmlFor={id}><span>{name}</span></label>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/FormCheckbox.js